module.exports = __webpack_public_path__ + "img/cw_banner2.59b2579c.png";